import styled from "styled-components";
import { Spinner } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"; // Importando o componente correto

export const Container = styled.div`
  min-height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: #f0f2f5;
  padding: 20px;
  box-sizing: border-box;
  position: relative;
  text-align: center;

  @media (max-width: 768px) {
    padding: 15px;
  }

  @media (max-width: 480px) {
    padding: 10px;
  }
`;

export const LoadingText = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin-top: 20px;
  margin-bottom: 10px;
`;

export const TextContainer = styled.div`
  color: #555;
  font-size: 14px;
  margin-top: 15px;
  font-weight: 400;
`;

// Aqui você aplica a rotação mais lenta no Spinner
export const SlowSpinner = styled(Spinner)`
  animation: spinner-border 1.4s linear infinite !important;
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  padding: 20px;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

export const ErrorBox = styled.div`
  background-color: #fff;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  width: 450px;
  text-align: center;
  position: relative;

  h2 {
    color: #d9534f;
    font-size: 22px;
    font-weight: bold;
  }

  h3 {
    color: #444;
    font-size: 20px;
    font-weight: bold;
  }

  p {
    color: #555;
    font-size: 14px;
  }
`;

export const ErrorIcon = styled(FontAwesomeIcon)`
  color: #d9534f;
  font-size: 40px;
  margin-bottom: 5px;
  animation: shakeZoom 1.7s ease-in-out infinite;

  @keyframes shakeZoom {
    0% {
      transform: rotate(0deg) scale(1);
    }
    12.5% {
      transform: rotate(10deg) scale(1.1);
    }
    25% {
      transform: rotate(0deg) scale(1);
    }
    37.5% {
      transform: rotate(-10deg) scale(1.1);
    }
    50% {
      transform: rotate(0deg) scale(1);
    }
    /* De 50% até 100% fica parado */
    100% {
      transform: rotate(0deg) scale(1);
    }
  }
`;
export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 25px;
  gap: 10px;
`;
export const ButtonReturn = styled.button`
  flex: 1;
  padding: 10px 20px;
  font-weight: 600;
  font-size: 16px;
  border-radius: 20px;
  cursor: pointer;
  border: none;
  transition: background-color 0.3s ease;
  background-color: #0274d8d3; /* azul */
  color: white;
  display: flex;
  align-items: center; /* Centraliza verticalmente */
  justify-content: center; /* Centraliza horizontalmente */

  &:hover {
    background-color: #025aa5;
  }
`;
export const ButtonSupport = styled.button`
  flex: 1;
  padding: 10px 20px;
  font-weight: 600;
  font-size: 16px;
  border-radius: 20px;
  cursor: pointer;
  border: none;
  transition: background-color 0.3s ease;
  background-color: #0274d8d3; /* azul */
  color: white;
  display: flex;
  align-items: center; /* Centraliza verticalmente */
  justify-content: center; /* Centraliza horizontalmente */
  text-decoration: none;

  &:hover {
    background-color: #025aa5;
    color: white; /* <- força a cor do texto a permanecer branca */
    text-decoration: none; /* <- opcional: remove sublinhado de link */
  }
`;
